import React from "react";
import Snackbar from "components/Snackbar/Snackbar.jsx";


function UserNotifications({ ...props }) {

	let {
		notification,
		notifications,
		onClose,
	} = props;

	if(!notification) return "";

	if(!Array.isArray(notifications)){
		notifications = [{state:true, message:notifications}];
	}

	return notifications.map((prop,key)=>{
	      if(!prop.state) return "";
	      return (
	        <Snackbar
	          key={key}
	          place="tr"
	          color="warning"
	          message={prop.message}
	          open={notification}
	          closeNotification={onClose}
	          close
	        />);
	    });
}

export default UserNotifications;


// WEBPACK FOOTER //
// ./src/components/UserNotifications/UserNotifications.jsx